module.exports = __webpack_public_path__ + "components/flag/static/square/ng-d12c084d9926fb3acffd2376ad4d3be8.svg";